










































































































import moment from 'moment'
import { Component, Vue, Ref } from 'vue-property-decorator'
import ListView from '@/components/ListView.vue'
import StateSelect from '@/components/Reservation/StateSelect.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'
import DateSelect from '@/components/DateSelect.vue'
import SelectNullBoolean from '@/components/SelectNullBoolean.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'

import { Reservation } from '../../types/reservation'
import { Dictionary } from 'vue-router/types/router'
import { formatDateForDisplay, getDateDisplayFormat } from '@/utils'

@Component({
  components: {
    ListView,
    StateSelect,
    ShopAutocomplete,
    DateSelect,
    SelectNullBoolean,
    CSVExportBtn,
    CustomerAutocomplete,
  },
})
export default class ReservationListView extends Vue {
  get headers() {
    return [
      {
        text: this.$t('reservation.text.reservationId'),
        value: 'id',
        width: 80,
        fixed: 'left',
      },
      {
        text: this.$t('reservation.text.shopCode'),
        value: 'shopCode',
        width: 60,
      },
      {
        text: this.$t('reservation.text.shopName'),
        value: 'shopName',
        width: 200,
      },
      {
        text: this.$t('reservation.text.visitDate'),
        value: 'date',
        width: 100,
      },
      { text: this.$t('reservation.text.visitTime'), value: 'time', width: 80 },
      {
        text: this.$t('reservation.text.state'),
        value: 'stateText',
        width: 100,
      },
      {
        text: this.$t('reservation.text.customerCode'),
        value: 'customerCode',
        width: 100,
      },
      { text: this.$t('reservation.text.appId'), value: 'userEmail' },
      { text: this.$t('reservation.text.reserverName'), value: 'reserver' },
      {
        text: this.$t('reservation.text.reservationRoute'),
        value: 'reservingWayText',
        width: 150,
      },
      {
        text: this.$t('reservation.text.registeredDateTime'),
        value: 'createdAt',
        width: 150,
      },
      {
        text: this.$t('reservation.text.updatedDateTime'),
        value: 'updatedAt',
        width: 150,
      },
      {
        text: this.$t('reservation.text.reviewPostedDateTime'),
        value: 'rating.created',
        width: 150,
      },
      {
        text: this.$t('reservation.text.customerDeletedFlag'),
        value: 'customerDeleted',
      },
    ]
  }
  filterDefinition = {
    search: { type: String, default: null },
    ordering: { type: String, default: '' },
    state: { type: Number, default: null },
    shop: { type: String, default: null },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
    rated: { type: Boolean, default: null },
    customer: { type: String, default: null },
    isRemoved: { type: Boolean, default: null },
  }
  filter: null | Dictionary<unknown> = null

  get totalCount() {
    return this.$api.reservations().count
  }

  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'id', label: t('reservation.csv.reservationId') },
      { key: 'isRemoved', label: t('reservation.csv.deletedFlag') },

      { key: 'shopCode', label: t('reservation.csv.shopCode') },
      { key: 'shopName', label: t('reservation.csv.shopName') },
      {
        key: (item: Reservation) =>
          formatDateForDisplay(item.date, this.$i18n.locale),
        label: t('reservation.csv.visitDate'),
      },
      { key: 'time', label: t('reservation.csv.visitTime') },

      { key: 'familyName', label: t('reservation.csv.familyName') },
      { key: 'givenName', label: t('reservation.csv.givenName') },
      ...(this.$i18n.locale === 'ja' ? [
        { key: 'familyNameKana', label: t('reservation.csv.familyNameKana') },
        { key: 'givenNameKana', label: t('reservation.csv.givenNameKana') },
      ] : []),

      { key: 'customerUserEmail', label: t('reservation.csv.appId') },
      { key: 'customerCode', label: t('reservation.csv.customerCode') },
      { key: 'customerPhoneNumber', label: t('reservation.csv.phoneNumber') },

      { key: 'reservingWayText', label: t('reservation.csv.reservationRoute') },
      { key: 'menuName', label: t('reservation.csv.menuName') },
      { key: 'stateText', label: t('reservation.csv.visitStatus') },

      { key: 'sumVisited', label: t('reservation.csv.visitCount') },
      {
        key: 'attendedStaffCode',
        label: t('reservation.csv.attendedStaffCode'),
      },
      {
        key: 'attendedStaffName',
        label: t('reservation.csv.attendedStaffName'),
      },
      {
        key: 'operationHistory.treatmentStaffCode',
        label: t('reservation.csv.counselingStaffCode'),
      },
      {
        key: 'operationHistory.treatmentStaffName',
        label: t('reservation.csv.counselingStaffName'),
      },
      {
        key: 'operationHistory.dyeingStaffCode1',
        label: t('reservation.csv.dyeingStaffCode1'),
      },
      {
        key: 'operationHistory.dyeingStaffName1',
        label: t('reservation.csv.dyeingStaffName1'),
      },
      {
        key: 'operationHistory.dyeingStaffCode2',
        label: t('reservation.csv.dyeingStaffCode2'),
      },
      {
        key: 'operationHistory.dyeingStaffName2',
        label: t('reservation.csv.dyeingStaffName2'),
      },
      {
        key: 'operationHistory.shampooStaffCode',
        label: t('reservation.csv.shampooStaffCode'),
      },
      {
        key: 'operationHistory.shampooStaffName',
        label: t('reservation.csv.shampooStaffName'),
      },
      {
        key: 'operationHistory.scalpProtectiveAgentText',
        label: t('reservation.csv.scalpProtectiveAgent'),
      },
      {
        key: 'treatmentName',
        label: t('reservation.csv.treatment'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.ratingPushNotified, this.$i18n.locale),
        label: t('reservation.csv.reviewPushDate'),
      },
      {
        key: (item: any) => extractTime(item.ratingPushNotified),
        label: t('reservation.csv.reviewPushTime'),
      },
      {
        key: 'rating.point',
        label: t('reservation.csv.reviewPoint'),
      },
      {
        key: 'rating.freeComment',
        label: t('reservation.csv.reviewComment'),
      },
      {
        key: (item: Reservation) =>
          formatDateForDisplay(item.rating?.created, this.$i18n.locale),
        label: t('reservation.csv.reviewPostedDate'),
      },
      {
        key: (item: Reservation) => extractTime(item.rating?.created),
        label: t('reservation.csv.reviewPostedTime'),
      },

      {
        key: (item: Reservation) =>
          formatDateForDisplay(item.createdAt, this.$i18n.locale),
        label: t('reservation.csv.createdDate'),
      },
      {
        key: (item: Reservation) => extractTime(item.createdAt),
        label: t('reservation.csv.createdTime'),
      },
      {
        key: (item: Reservation) => {
          const prevDate = item.previousReservedDate
          const formatDate = getDateDisplayFormat(this.$i18n.locale)
          const prev45 = moment(item.date)
            .add(-45, 'days')
            .format(formatDate)
          if (prevDate && prev45 <= prevDate) {
            const total = item.sumVisited
            if (total >= 4) return 'RT'
            if (total === 2 || total === 3) return 'HT'
          }
        },
        label: t('reservation.csv.rtHt'),
      },
      {
        key: (item: Reservation) => item.previousReservedDate,
        label: t('reservation.csv.previousVisitDate'),
      },
      {
        key: (item: Reservation) => item.scalpCareName,
        label: t('reservation.csv.option'),
      },

      {
        key: (item: Reservation) =>
          formatDateForDisplay(item.updatedAt, this.$i18n.locale),
        label: t('reservation.csv.updatedDate'),
      },
      {
        key: (item: Reservation) => extractTime(item.updatedAt),
        label: t('reservation.csv.updatedTime'),
      },
      {
        key: (item: Reservation) => item.receivesInfo,
        label: t('reservation.csv.receiveNotification'),
      },
      {
        key: (item: Reservation) => item.customerDeleted,
        label: t('reservation.csv.customerDeletedFlag'),
      },
      {
        key: (item: Reservation) => item.trendColor,
        label: t('reservation.csv.trendColor'),
      },
      {
        key: (item: Reservation) => item.hotpepperReservationNumber,
        label: t('reservation.csv.hotpepperReservationNumber'),
      },
      {
        key: (item: Reservation) => item.reservationPhoneNumber,
        label: t('reservation.csv.reservationPhoneNumber'),
      },
    ]
  }
  get csvFetch() {
    return () => this.$api.reservations().list(this.listView.query)
  }

  get staffLoggedIn(): boolean {
    return this.$store.getters.staffLoggedIn
  }

  @Ref() readonly listView!: ListView

  getReserverName({ fullName, fullNameKana }: Reservation) {
    return `${fullNameKana} (${fullName})`
  }

  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
  }
}
const extractTime = (value: string | undefined) =>
  value ? moment(value).format('HH:mm') : ''
